import React from 'react'
import {Container, Tabs, Tab, Form} from 'react-bootstrap'
import CompLinkHeader from 'components/riwayat/compLinkHeader'
import './style.css'

export default function main() {
    return (
        <Container className="page-statistik-transaksi">
            <CompLinkHeader to="/profile" back="Transaksi" title="Statistik Transaksi" />
            <div className="statistik-transaksi">    
                <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example" className="mb-3">
                    {
                        Data.map((data, i) => {
                            return (
                                <Tab key={i} eventKey={data.link} title={data.title}>  
                                    {i === 0? <Total /> : null}
                                    {i === 1? <Malmora /> : null}
                                </Tab>
                            )
                        })
                    }
                </Tabs>
            </div>
        </Container>
    )
}

const Data = [
    {link:"_total", title:"Total"},{link:"_malmora", title:"Malmora"},{link:"titik", title:"Judul"}
]



function Total() {
    return (
       <div>
            {
                Statistik_Data.map((data, i) => {
                    return (
                        <div className="total-statistik">
                        <h4 key={i}>{data.title}</h4>
                        <div className="data-transaksi-statistik">
                            <div className="bulan-lalu">
                                <small>Bulan Lalu (Juli)</small>
                                <h4>Rp. 150.000</h4>
                            </div>
                            <div className="border"></div>
                            <div className="bulan-ini">
                                <small>Bulan ini (Agustus)</small>
                                <h4>Rp. 100.000</h4>
                            </div>
                        </div>
                       </div>
                    )
                })
            }
            <div className="selisih-transaksi">
                <h6>Selisih Transaksi</h6>
                <h3>Rp.150.000</h3>
            </div>
        </div>
    )
}

const Statistik_Data = [
    {title:"Total Transaksi Malmora"},{title:"Total Transaksi Berberkah"},{title:"Total Transaksi"}
]

function Malmora() {
    return (
        <div className="waktu-transaksi">
            <Form>
                <label>Bulan</label>
                <select name="pets" id="pet-select">
                    {
                        Bulan.map((bln, i) => {
                            return (
                                <option key={i} value={i + 1}>{bln.name}</option>
                            )
                        })
                    }                 
                </select>
                <label>Tahun</label>
                <select name="pets" id="pet">
                    {
                        Tahun.map((thn, i) => {
                            return (
                                <option key={i} value={i + 1}>{thn.name}</option>
                            )
                        })
                    }                 
                </select>
            </Form>
        </div>
    )
}

const Bulan = [
    {name:"Januari"},{name:"Februari"},{name:"Maret"},{name:"April"},{name:"Mei"},{name:"Juni"},{name:"Juli"},{name:"Agustus"},{name:"September"},{name:"Oktober"},{name:"November"},{name:"Desember"}
]

const Tahun = [
    {name:2000},{name:2001},{name:2002},{name:2003},{name:2004},{name:2005},{name:2006},{name:2007},{name:2008},{name:2009},{name:2010},{name:2011},{name:2012},{name:2013},{name:2014},{name:2015},{name:2016},{name:2017},{name:2018},{name:2019},{name:2020},{name:2021},{name:2022},{name:2023},{name:2024},{name:2025},{name:2026},{name:2027},{name:2028},{name:2029},{name:2030},{name:2031},{name:2032},{name:2033},{name:2034},{name:2035}
]

